import { PublicClientApplication } from "@azure/msal-browser";
import { createMsalInstance } from "./modules/auth/msal-config";

export type MsalConfig = {
  instance: PublicClientApplication;
  loginRequest: { scopes: string[] };
};

type EnvConfig = {
  API_URL: string;
  SIGNALR_SENSOR_SUBSCRIBE_URL: string;
  SIGNALR_ALARM_SUBSCRIBE_URL: string;
  SIGNALR_ERROR_MESSAGE_SUBSCRIBE_URL: string;
  AZURE_AD_TENANT_ID: string;
  AZURE_AD_CLIENT_ID: string;
  REDIRECT_URI: string;
  GF_SERVER_ROOT_URL: string;
  MSAL_CONFIG: MsalConfig;
};

let envConfig: Record<keyof EnvConfig, string | MsalConfig> = {
  API_URL: "",
  SIGNALR_SENSOR_SUBSCRIBE_URL: "",
  SIGNALR_ALARM_SUBSCRIBE_URL: "",
  SIGNALR_ERROR_MESSAGE_SUBSCRIBE_URL: "",
  AZURE_AD_TENANT_ID: "",
  AZURE_AD_CLIENT_ID: "",
  REDIRECT_URI: "",
  GF_SERVER_ROOT_URL: "",
  MSAL_CONFIG: {} as MsalConfig,
};

export async function loadEnvConfig(): Promise<void> {
  try {
    const response = await fetch("/env.json");
    if (!response.ok) {
      throw new Error("Failed to load env.json");
    }
    const envFileContent = await response.json();

    envConfig = {
      ...envFileContent,
      MSAL_CONFIG: {
        instance: createMsalInstance(
          envFileContent.AZURE_AD_CLIENT_ID,
          envFileContent.AZURE_AD_TENANT_ID,
          envFileContent.REDIRECT_URI,
        ),
        loginRequest: {
          scopes: [envFileContent.AZURE_AD_CLIENT_ID + "/.default"],
        },
      },
    };
  } catch (error) {
    console.error("Error loading env.json:", error);
  }
}

export function getEnvConfig(key: keyof EnvConfig): string | MsalConfig {
  return envConfig[key];
}
